import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { Menu } from '@headlessui/react';
import { Menu as MenuIcon, X } from 'lucide-react';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`fixed w-full z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white/80 backdrop-blur-lg shadow-lg' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <Link to="/" className="flex items-center space-x-2">
            <span className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
              Docu
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link to="/" className="nav-link">Home</Link>
            <Link to="/privacy" className="nav-link">Privacy Policy</Link>
            <Link to="/terms" className="nav-link">Terms of Service</Link>
            <Link to="/contact" className="nav-link">Contact</Link>
            <a 
              href="https://app.docu.com" 
              className="bg-blue-600 text-white px-6 py-2 rounded-full hover:bg-blue-700 transition-colors"
            >
              Launch App
            </a>
          </nav>

          {/* Mobile Navigation */}
          <Menu as="div" className="md:hidden">
            {({ open }) => (
              <>
                <Menu.Button className="p-2">
                  {open ? <X size={24} /> : <MenuIcon size={24} />}
                </Menu.Button>

                <AnimatePresence>
                  {open && (
                    <Menu.Items
                      as={motion.div}
                      initial={{ opacity: 0, y: -20 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: -20 }}
                      className="absolute top-full right-0 w-full bg-white shadow-lg rounded-b-xl py-4 px-4"
                    >
                      <div className="flex flex-col space-y-4">
                        <Menu.Item>
                          <Link to="/" className="block py-2">Home</Link>
                        </Menu.Item>
                        <Menu.Item>
                          <Link to="/privacy" className="block py-2">Privacy Policy</Link>
                        </Menu.Item>
                        <Menu.Item>
                          <Link to="/terms" className="block py-2">Terms of Service</Link>
                        </Menu.Item>
                        <Menu.Item>
                          <Link to="/contact" className="block py-2">Contact</Link>
                        </Menu.Item>
                        <Menu.Item>
                          <a 
                            href="https://app.docu.com" 
                            className="bg-blue-600 text-white px-6 py-2 rounded-full text-center"
                          >
                            Launch App
                          </a>
                        </Menu.Item>
                      </div>
                    </Menu.Items>
                  )}
                </AnimatePresence>
              </>
            )}
          </Menu>
        </div>
      </div>
    </header>
  );
}